import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  homologacao: {},
  arquivos: []
});

function homologacaoReducer(state = initialState, action) {
  switch (action.type) {
    case types.HOMOLOGACAO_ARQUIVOS_START:
    case types.HOMOLOGACAO_START: {
      return startLoad(state);
    }

    case types.HOMOLOGACAO_ARQUIVOS_ERROR:
    case types.HOMOLOGACAO_ERROR: {
      return endLoad(state);
    }

    case types.HOMOLOGACAO_SUCCESS: {
      return endLoad(state.set('homologacao', fromJS(action.payload)));
    }
    case types.HOMOLOGACAO_ARQUIVOS_SUCCESS: {
      return endLoad(state.set('arquivos', fromJS(action.payload)));
    }
  }

  return state;
}

export default homologacaoReducer;
